import { ProcessTemplatesTranslation } from '@/assets/locales/views/admin/processTemplates/processTemplates.translation.en.ts';

export const processTemplatesTranslation: ProcessTemplatesTranslation = {
  deleteConfirmation: 'Czy na pewno chcesz usunąć tę templatkę procesu?',
  form: {
    addNewRedFlag: 'Dodaj nową czerwoną flagę',
    budget: 'Budżet',
    cancel: 'Anuluj',
    candidateScreening: 'Weryfikacja kandydatów',
    deleteKeywordConfirmation: 'Czy na pewno chcesz usunąć to słowo kluczowe?',
    description: 'Opis',
    descriptionWeightHint:
      'Możesz opcjonalnie nadać wagę wymaganiu, dopisując na jego końcu [w:X], gdzie X to liczba od 1 do 5, np. "JavaScript [w:5]". Tego znacznika możesz użyć przy dowolnej liczbie wymagań.',
    generalInfo: 'Informacje ogólne',
    jobDescription: 'Opis stanowiska',
    keywordDuplicate: 'To słowo kluczowe już istnieje',
    keywords: 'Słowa kluczowe',
    keywordsHelp: 'Słowa kluczowe do automatycznego wykrywania szablonu',
    keywordsPlaceholder: 'Wpisz słowo kluczowe (np. sprzedaż, konsultant)',
    keywordTooShort: 'Słowo kluczowe musi mieć co najmniej 2 znaki',
    locationType: 'Typ lokalizacji',
    locationTypes: {
      HYBRID: 'Hybrydowo',
      OFFICE: 'Biuro',
      REMOTE: 'Zdalnie',
    },
    name: 'Nazwa',
    noKeywords: 'Nie dodano jeszcze słów kluczowych',
    none: 'Brak',
    positionDetails: 'Szczegóły stanowiska',
    recruitmentType: 'Typ szablonu',
    recruitmentTypes: {
      B2C: 'B2C',
      REGULAR: 'Standardowy',
    },
    redFlagDuplicate: 'Ta czerwona flaga już istnieje',
    redFlagsHelp:
      'Wypisz poniżej czerwone flagi, które należy uwzględnić podczas dopasowywania kandydatów do procesu.',
    redFlagsPlaceholder: 'wpisz czerwoną flagę',
    redFlagTooShort: 'Czerwona flaga musi mieć co najmniej 2 znaki',
    save: 'Zapisz',
    tolerance: 'Tolerancja',
  },
  noTemplatesFound: 'Nie znaleziono templatek.',
  selectOrAddTemplate: 'Wybierz templatkę z listy lub dodaj nową.',
  title: 'Szablony procesów',
  unsavedChangesDialog: {
    cancel: 'Anuluj',
    content: 'Masz niezapisane zmiany. Zapisz je przed opuszczeniem tego widoku.',
    save: 'Zapisz',
    title: 'Niezapisane zmiany',
  },
};
